import React from "react";
import About from "../components/About";
import DownloadSection from "../components/DownloadSection";
import Features from "../components/Features";
// import Footer from "../components/footer";
import HeroSection from "../components/HeroSection";
import Navbar from "../components/Navbar";
import Screenshots from "../components/Screenshots";
import Services from "../components/Services";
import FooterTwo from "../components/Footer";


const Home = () => {
  return (
    <>
      <Navbar />
      <HeroSection />
      <About />
      <Services />
      <Features />
      <DownloadSection/>
      <Screenshots/>
      {/* <Footer/> */}
      <FooterTwo />
    </>
  );
};

export default Home;
